export default __webpack_public_path__ + "static/bigbazaar-14df1ac31f35a3499c6a6d4e545122eb.jpg";